export const headers = {
  initialHeaders: [
    { title: "Tipo De Documento", field: "documentTypeName", child: null },
    { title: "Identificación", field: "documentNumber", child: null },
    { title: "Nombres", field: "firstName, secondName", child: null },
    { title: "Apellidos", field: "surname, secondSurname", child: null,},
    {
      title: "Tipo Usuario",
      field: "type",
      child: null,
    },
    {
      title: "Estado",
      field: "status",
      child: null,
    },
  ],
  otherHeaders: [
    {
      title: "Usuario",
      field: "username",
      child: null,
    },
    {
      title: "Cargo",
      field: "charge",
      child: "denomination",
    },
    {
      title: "N° Celular",
      field: "cellPhoneNumber",
      child: null,
    },
    {
      title: "N° Teléfono",
      field: "phone",
      child: null,
    },
    {
      title: "Género",
      field: "domainGender",
      child: null,
    },
    {
      title: "Contraseña",
      field: "password",
      child: null,
    },
    {
      title: "Estado",
      field: "status",
      child: null,
    },
    {
      title: "Fecha De Creación",
      field: "creationDate",
      child: null,
    },
    {
      title: "Correo Personal",
      field: "externalEmail",
      child: null,
    },
    {
      title: "Correo Corporativo",
      field: "internalEmail",
      child: null,
    },
    {
      title: "Roles",
      field: "roles",
      child: null,
    },
    {
      title: "Fecha De Nacimiento",
      field: "dateBirth",
      child: null,
    },
  ],
};

export const defaultValues = {
  firstName: null,
  secondName: null,
  surname: null,
  secondSurname: null,
  documentType: null,
  documentNumber: null,
  email: null,
  phone: 0,
  type: null,
  cellPhoneNumber: 0,
  gender: null,
  status: null,
  creationUser: "Developer",
};
